import { Navigate } from "react-router-dom";

import { useAuth } from "@/contexts/AuthContext";
import { useTenantSwitcher } from "@/contexts/TenantSwitcherContext";
import { PaidPlanRoute } from "@/components/shared/PaidPlanRoute";
import { TenantRequiredRoute } from "@/components/shared/TenantRequiredRoute";
import { SolicitudesPage } from "@/pages/solicitudes/solicitudes-page";
import { SolicitudDetailPage } from "@/pages/solicitudes/solicitud-detail-page";

/**
 * Dispatches /requests and /requests/:id to Solicitudes for tenant accountants; others go to dashboard.
 *
 * BOTH ARE WRAPPED IN PaidPlanRoute. The page's only query hits
 * GET /fiscal-agenda/tenant-accountant-requests, which calls assertPaidPlan
 * (fiscal.controller.ts:257) and 403s for a free tenant. Without the gate an
 * accountant opening a FREE client sees an error page, and because the query
 * uses refetchOnWindowFocus the 403 re-fires on every tab focus — that is how
 * one tenant produced 124 failed requests between 2026-08-31 and 2026-09-02.
 *
 * PaidPlanRoute reads the ACTIVE tenant's planId and its isFreePlan mirrors the
 * backend's hasPaidPlan, so the gate and the guard agree by construction rather
 * than by two lists being kept in sync.
 */
export function RequestsListRoute(): JSX.Element {
  const { user } = useAuth();
  const { activeTenant } = useTenantSwitcher();

  if (user?.role === "accountant" && activeTenant) {
    return (
      <TenantRequiredRoute>
        <PaidPlanRoute>
          <SolicitudesPage />
        </PaidPlanRoute>
      </TenantRequiredRoute>
    );
  }
  return <Navigate to="/dashboard" replace />;
}

export function RequestsDetailRoute(): JSX.Element {
  const { user } = useAuth();
  const { activeTenant } = useTenantSwitcher();

  if (user?.role === "accountant" && activeTenant) {
    return (
      <TenantRequiredRoute>
        <PaidPlanRoute>
          <SolicitudDetailPage />
        </PaidPlanRoute>
      </TenantRequiredRoute>
    );
  }
  return <Navigate to="/dashboard" replace />;
}
